
import { defineComponent, ref, watch, computed } from 'vue';
import { debounce, cloneDeep } from 'lodash';
import { useStore } from '@/store';
import { formDefaults } from '@/constants';
import NumberWithMetricInput from '@/components/form-controls/NumberWithMetricInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import GoogleDriverPicker from '@/components/form-controls/GoogleDriverPicker.vue';

export default defineComponent({
  name: 'UserSettingsManager',
  components: {
    NumberWithMetricInput,
    TextInput,
    ButtonInput,
    GoogleDriverPicker
  },
  setup() {
    const store = useStore();
    const userId = store.state.auth.firebaseUser?.uid;
    const userSettingsDefaults = computed(
      () => store.getters.userSettings.get.find(setting => setting.userId === userId) ?? formDefaults.userSettings
    );
    const localUserSettingsState = ref(cloneDeep(userSettingsDefaults.value));

    watch(userSettingsDefaults, () => {
      localUserSettingsState.value = cloneDeep(userSettingsDefaults.value);
    });

    const label = ref('Save');
    const revertLabel = debounce(
      () => {
        label.value = 'Save';
      },
      1500,
      {
        leading: false,
        trailing: true
      }
    );
    const saveUserSettings = async () => {
      if (!userId) return;

      const userSettings = store.getters.userSettings.get;
      const settings = userSettings.find(setting => setting.userId === userId);

      if (settings) {
        await store.dispatch.userSettings.update({ ...localUserSettingsState.value, userId });
      } else {
        await store.dispatch.userSettings.create({ ...localUserSettingsState.value, userId });
      }

      label.value = 'Saved!';
      revertLabel();
    };

    return {
      label,
      localUserSettingsState,
      saveUserSettings
    };
  }
});
